module.exports = __webpack_public_path__ + "img/4.cd70d0fb.jpg";